import { cx } from '@/lib/cx';
import { Contador } from '@/ui/components/contador';
import { type Lote, type ResultadoItemLote } from '@fiscoai/contracts';

import { PONTO_DO_TOM, RESULTADOS } from './rotulos';

interface Props {
  lote: Lote;
  filtro: ResultadoItemLote | undefined;
  aoFiltrar: (resultado: ResultadoItemLote | undefined) => void;
}

/** Contadores por resultado que também filtram a lista (clicar de novo tira o filtro). */
export function ContadoresLote({ lote, filtro, aoFiltrar }: Props) {
  const visiveis = RESULTADOS.filter((r) => lote.contadores[r.valor] > 0);
  return (
    <ul className="grid grid-cols-2 gap-2 sm:grid-cols-3" aria-label="Resultado por tipo">
      {visiveis.map((r) => {
        const ativo = filtro === r.valor;
        return (
          <li key={r.valor}>
            <button
              type="button"
              aria-pressed={ativo}
              onClick={() => {
                aoFiltrar(ativo ? undefined : r.valor);
              }}
              className={cx(
                'grid w-full gap-0.5 rounded-cartao border px-3 py-2 text-left transition-colors duration-[var(--duracao-rapida)]',
                ativo
                  ? 'border-marca bg-marca-suave'
                  : 'border-borda bg-superficie hover:bg-superficie-hover',
              )}
            >
              <span className="flex items-center gap-1.5 text-xs text-texto-suave">
                <span aria-hidden className={cx('size-2 rounded-pilula', PONTO_DO_TOM[r.tom])} />
                {r.rotulo}
              </span>
              <Contador valor={lote.contadores[r.valor]} className="text-xl font-semibold" />
            </button>
          </li>
        );
      })}
    </ul>
  );
}
